import { cn } from '@/lib/cn';

/**
 * Skeletons mirror the real layout rather than showing a spinner on an empty
 * page, so nothing jumps when the data lands. The pulse is motion-safe only.
 */
export function Skeleton({ className }: { className?: string }) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        'rounded-sm bg-sunken',
        'motion-safe:[animation:shimmer_1.6s_ease-in-out_infinite]',
        className,
      )}
    />
  );
}

export function TableSkeleton({ rows = 6, columns = 5 }: { rows?: number; columns?: number }) {
  return (
    <div className="divide-y divide-line">
      {Array.from({ length: rows }, (_, rowIndex) => (
        <div key={rowIndex} className="flex items-center gap-4 px-4 py-3">
          {Array.from({ length: columns }, (_, columnIndex) => (
            <Skeleton
              key={columnIndex}
              className={cn('h-3.5', columnIndex === 0 ? 'w-28' : 'flex-1')}
            />
          ))}
        </div>
      ))}
    </div>
  );
}
